import React, { createContext, useState } from 'react';

const ElementViewBuilderContext = createContext({});
const { Provider } = ElementViewBuilderContext;

const initialState = [];
let elementViewIncrement = 0;

const getElementViewId = () => {
	elementViewIncrement += 1;
	return `element-view-${elementViewIncrement}`;
};

const ElementViewBuilderProvider = ({ children }) => {
	const [stack, setStack] = useState(initialState);

	const setElementView = ({ mode = 'replace', ...props } = {}) =>
		setStack(prev => {
			const nextPayload = {
				...props,
				__viewId: props.__viewId || getElementViewId(),
			};

			if (mode === 'stack' && prev.length > 0) return [...prev, nextPayload];

			return [nextPayload];
		});

	const cleanElementView = viewId =>
		setStack(prev => {
			if (prev.length === 0) return prev;
			if (!viewId) return prev.slice(0, -1);

			return prev.filter(({ __viewId }) => __viewId !== viewId);
		});

	const payload = stack[stack.length - 1] || {};
	const value = { payload, stack, setElementView, cleanElementView };

	return <Provider value={value}>{children}</Provider>;
};

export { ElementViewBuilderProvider, ElementViewBuilderContext };
